export const DEPARTURE_CITIES_FILTERS_ID = 2
export const DEPARTURE_CITIES_FILTERS_KEY = 'departureCities'
export const DEPARTURE_DATES_FILTERS_ID = 3
export const DEPARTURE_DATES_FILTERS_KEY = 'departureDates'
export const DEPARTURE_DATES_FLEXIBILITY_OPTIONS = [0, 1, 3, 7]
export const DURATIONS_FILTERS_ID = 1
export const DURATIONS_FILTERS_KEY = 'durations'
export const TRANSPORTATION_FILTERS_KEY = 'transportation'

export const ALL_FILTERS_KEYS = [
  DEPARTURE_CITIES_FILTERS_KEY,
  DEPARTURE_DATES_FILTERS_KEY,
  DURATIONS_FILTERS_KEY,
  TRANSPORTATION_FILTERS_KEY
]

export const DEPARTURE_CITIES_NO_TRANSPORTATION_CODES = ['XXX', 'NONE']
